import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  phoneNumberForSupport: new analytics.Event({
    name: 'Phone number for integration support submitted',
    description: 'Merchant submits phone number to be reached for integration support',
    action: analytics.EVENT_ACTION.FORM_SUBMIT,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
    userAttributes: [],
  }),
};
